export const gCodeServerselect = {
	'666': {
		'area': 1,
		'platid': 0,
		'partition': 0,
		'selectCode': '_666',
		'type': 1, // 1表示H5手游游戏，2表示PC端游游戏
		'pgk': 'com.tencent.tmgp.wesix'
	},
	'peng': {
		'area': 1,
		'platid': 0,
		'partition': 0,
		'selectCode': 'PENG',
		'type': 1,
		'pgk': 'com.tencent.peng'
	},
	'jgm': {
		'area': 1,
		'platid': 0,
		'partition': 0,
		'selectCode': 'JGM',
		'type': 1,
		'pgk': 'com.tencent.jgm'
	},
	'cube': {
		'area': 1,
		'platid': 0,
		'partition': 0,
		'selectCode': 'CUBE',
		'type': 1,
		'pgk': 'com.tencent.LEGOCUBE'
	},
	'zjzk': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'ZJZK',
		'type': 1,
		'pgk': 'com.tencent.tmgp.zjzk'
	},
	'jx3': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'JX3',
		'type': 1,
		'pgk': 'com.tencent.tmgp.jx3m'
	},
	'slg': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'SLG',
		'type': 1,
		'pgk': 'com.tencent.tmgp.wec'
	},
	'miku': {
		'area': 1,
		'platid': 0,
		'partition': 0,
		'selectCode': 'MIKU',
		'type': 1,
		'pgk': 'com.tencent.tmgp.miku'
	},
	'cfm': {
		'area': 1,
		'platid': 0,
		'partition': 0,
		'selectCode': 'CFM',
		'type': 1,
		'pgk': 'com.tencent.tmgp.cf'
	},
	'f': {
		'area': 1,
		'platid': 0,
		'partition': 0,
		'selectCode': 'F',
		'type': 1,
		'pgk': ''
	},
	'3new': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': '_3NEW',
		'type': 1,
		'pgk': 'com.tencent.tmgp.zlong'
	},
	'yxzj': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'YXZJ',
		'type': 1,
		'pgk': 'com.tencent.tmgp.sgame'
	},
	'xiawa': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'XIAWA',
		'type': 1,
		'pgk': 'com.tencent.lzhx'
	},
	'zqnba': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'ZQNBA',
		'type': 1,
		'pgk': ''
	},
	'shihun': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'SHIHUN',
		'type': 1,
		'pgk': 'com.tencent.shihun.android'
	},
	'ym': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'YM',
		'type': 1,
		'pgk': 'com.tencent.yunmeng'
	},
	'3s': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': '_3S',
		'type': 1,
		'pgk': 'com.tencent.ssss'
	},
	'wmsj': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'WMSJ',
		'type': 1,
		'pgk': 'com.tencent.wmsj'
	},
	'hx': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'HX',
		'type': 1,
		'pgk': 'com.tencent.hxgame'
	},
	'nntgjgyx': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'NNTGJGYX',
		'type': 1,
		'pgk': 'com.tencent.nntg.linekong'
	},
	'zht': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'ZHT',
		'type': 1,
		'pgk': 'com.tencent.tmgp.seal'
	},
	'swy': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'SWY',
		'type': 1,
		'pgk': 'com.tencent.swy'
	},
	'speedm': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'SPEEDM',
		'type': 1,
		'pgk': 'com.tencent.tmgp.speedmobile'
	},
	'lr': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'LR',
		'type': 1,
		'pgk': 'com.tencent.hxh'
	},
	'yxwd': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'YXWD',
		'type': 1,
		'pgk': 'com.tencent.tmgp.yxwdzzjy'
	},
	'moyu': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'MOYU',
		'type': 1,
		'pgk': 'com.tencent.moyu'
	},
	'hwz': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'HWZ',
		'type': 1,
		'pgk': 'com.tencent.tapenjoy.actx'
	},
	'dn': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'DN',
		'type': 1,
		'pgk': 'com.tencent.tmgp.dragonnest'
	},
	'mir': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'MIR',
		'type': 1,
		'pgk': ''
	},
	'qjjx': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'QJJX',
		'type': 1,
		'pgk': 'com.tencent.tmgp.tmsk.qj2'
	},
	'tlbb': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'TLBB',
		'type': 1,
		'pgk': 'com.tencent.tmgp.tstl'
	},
	'jx3': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'JX3',
		'type': 1,
		'pgk': 'com.tencent.tmgp.jx3m'
	},
	'gwgo': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'GWGO',
		'type': 1,
		'pgk': 'com.tencent.gwgo'
	},
	'football': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'FOOTBALL',
		'type': 1,
		'pgk': 'com.tencent.zqry2018'
	},
	'ffom': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'FFOM',
		'type': 1,
		'pgk': 'com.tencent.tmgp.ffom'
	},
	'wepop': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'WEPOP',
		'type': 1,
		'pgk': 'com.tencent.tmgp.WePop'
	},
	'mhzx': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'MHZX',
		'type': 1,
		'pgk': 'com.tencent.tmgp.mhzxsy'
	},
	'yw': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'YW',
		'type': 1,
		'pgk': 'com.tencent.ft'
	},
	'lycqsh': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'LYCQSH',
		'type': 1,
		'pgk': 'com.tencent.lycqsh'
	},
	'seiya': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'SEIYA',
		'type': 1,
		'pgk': ''
	},
	'djwk': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'DJWK',
		'type': 1,
		'pgk': 'com.tencent.tmgp.fcicv'
	},
	'ffm': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'FFM',
		'type': 1,
		'pgk': 'com.tencent.fifamobile'
	},
	'xycq': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'XYCQ',
		'type': 1,
		'pgk': 'com.tencent.tmgp.xymobile'
	},
	'xj4': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'XJ4',
		'type': 1,
		'pgk': 'com.tencent.xishanju.xj4'
	},
	'hyrz': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'HYRZ',
		'type': 1,
		'pgk': 'com.tencent.KiHan'
	},
	'hyrzol': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'HYRZOL',
		'type': 1,
		'pgk': 'com.tencent.hyrzol'
	},
	'ylzt': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'YLZT',
		'type': 1,
		'pgk': 'com.tencent.tmgp.ylm'
	},
	'kofmy': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'KOFMY',
		'type': 1,
		'pgk': 'com.tencent.kof'
	},
	'ysyy': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'YSYY',
		'type': 1,
		'pgk': 'com.tencent.tako.muses'
	},
	'raz': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'RAZ',
		'type': 1,
		'pgk': 'com.tencent.raziel'
	},
	'qmzg2': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'QMZG2',
		'type': 1,
		'pgk': 'com.tencent.qmzg'
	},
	'hongjing': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'HONGJING',
		'type': 1,
		'pgk': 'com.tencent.tmgp.hjol'
	},
	'aba': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'ABA',
		'type': 1,
		'pgk': 'com.tencent.tmgp.redfox'
	},
	'dp': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'DP',
		'type': 1,
		'pgk': 'com.tencent.tmgp.dpcq'
	},
	'kok': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'KOK',
		'type': 1,
		'pgk': 'com.tencent.wok'
	},
	'bwzy': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'BWZY',
		'type': 1,
		'pgk': 'com.tencent.tmgp.sgqyz'
	},
	'cqsj3d': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'CQSJ3D',
		'type': 1,
		'pgk': 'com.tencent.woool3d'
	},
	'cqsj': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'CQSJ',
		'type': 1,
		'pgk': 'com.tencent.cqsj'
	},
	'x5m': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'X5M',
		'type': 1,
		'pgk': 'com.tencent.tmgp.qqx5'
	},
	'hdl': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'HDL',
		'type': 1,
		'pgk': 'com.tencent.shootgame'
	},
	'moli': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'MOLI',
		'type': 1,
		'pgk': ''
	},
	'mt4': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'MT4',
		'type': 1,
		'pgk': 'com.tencent.tmgp.mt4'
	},
	'poe': {
		'area': 1,
		'platid': 1,
		'partition': 0,
		'selectCode': 'POE',
		'type': 2,
		'pgk': ''
	},
	'fo4': {
		'area': 1,
		'platid': 1,
		'partition': 0,
		'selectCode': 'FO4',
		'type': 2,
		'pgk': ''
	},
	'nba2kx': {
		'area': 1,
		'platid': 1,
		'partition': 0,
		'selectCode': 'NBA2KX',
		'type': 2,
		'pgk': ''
	},
	'wuxia': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'WUXIA',
		'type': 2,
		'pgk': ''
	},
	'yl': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'YL',
		'type': 2,
		'pgk': ''
	},
	'age': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'AGE',
		'type': 2,
		'pgk': ''
	},
	'x52': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'X52',
		'type': 2,
		'pgk': ''
	},
	'quanyou': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'QUANYOU',
		'type': 1,
		'pgk': 'com.tencent.yoozoo.got.wintercoming'
	},
	'wpzs': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'WPZS',
		'type': 1,
		'pgk': 'com.tencent.af'
	},
	'ddzzq': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'DDZZQ',
		'type': 1,
		'pgk': 'com.ilongyuan.autochess.ly_pre'
	},
	'longzhu': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'LONGZHU',
		'type': 1,
		'pgk': 'com.tencent.tmgp.db3d'
	},
	'ddt': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'DDT',
		'type': 1,
		'pgk': 'com.tencent.tmgp.ddtank'
	},
	'xylz': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'XYLZ',
		'type': 1,
		'pgk': 'com.tencent.tmgp.vgame'
	},
	'rpg': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'RPG',
		'type': 1,
		'pgk': 'com.tencent.tmgp.palol'
	},
	'ysdl': {
		'area': 1,
		'platid': 0,
		'partition': 0,
		'selectCode': 'YSDL',
		'type': 1,
		'pgk': 'com.tencent.elemental'
	},
	'wdqy': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'WDQY',
		'type': 1,
		'pgk': 'com.tencent.wdqy'
	},
	'fish': {
		'area': 1,
		'platid': 0,
		'partition': 0,
		'selectCode': 'FISH',
		'type': 1,
		'pgk': 'com.tencent.hlfish'
	},
	'yxsm': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'YXSM',
		'type': 1,
		'pgk': 'com.qqgame.mic'
	},
	'fifa': {
		'area': 1,
		'platid': 1,
		'partition': 0,
		'selectCode': 'FIFA',
		'type': 2,
		'pgk': 'com.tencent.FIFA.duanyou'
	},
	'xxsy': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'XXSY',
		'type': 1,
		'pgk': 'com.tencent.tmgp.xxsy'
	},
	'jxqy': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'JXQY',
		'type': 1,
		'pgk': 'com.tencent.tmgp.jxqy'
	},
	'yrzx': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'YRZX',
		'type': 1,
		'pgk': 'com.tencent.YiRen'
	},
	'sg': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'SG',
		'type': 2,
		'pgk': ''
	},
	'speed': {
		'area': 1,
		'platid': 1,
		'partition': 0,
		'selectCode': 'SPEED',
		'type': 2,
		'pgk': ''
	},
	'jxqy2': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'JXQY2',
		'type': 1,
		'pgk': 'com.tencent.tmgp.jxqy2'
	},
	'ty': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'TY',
		'type': 1,
		'pgk': 'com.tencent.tmgp.wuxia'
	},
	'x5': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'X5',
		'type': 2,
		'pgk': ''
	},
	'srpg': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'SRPG',
		'type': 1,
		'pgk': 'com.tencent.zgqyz'
	},
	'dnf': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'DNF',
		'type': 2,
		'pgk': ''
	},
	'vega': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'VEGA',
		'type': 1,
		'pgk': 'com.tencent.vega'
	},
	'wod': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'WOD',
		'type': 1,
		'pgk': 'com.tencent.wod'
	},
	'ywlljx': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'YWLLJX',
		'type': 1,
		'pgk': 'com.tencent.ftp'
	},
	'shanhai': {
		'area': 1,
		'platid': 1,
		'partition': 1,
		'selectCode': 'SHANHAI',
		'type': 1,
		'pgk': 'com.tencent.tmgp.djsy'
	},
}



// WEBPACK FOOTER //
// ./src/components/actModules/h5/assets/js/gCodeServerselect.js